import React from 'react';

interface LogoProps {
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = '', showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-sm"
      >
        <defs>
          {/* Çay buharı için gradient */}
          <linearGradient id="steam-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#10b981" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#10b981" stopOpacity="0.2" />
          </linearGradient>

          {/* Çay bardağı için gradient */}
          <linearGradient id="cup-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#f1f5f9" />
          </linearGradient>

          {/* Çay sıvısı için gradient */}
          <radialGradient id="tea-gradient" cx="50%" cy="30%" r="60%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#d97706" />
          </radialGradient>

          {/* Çember arka plan için gradient */}
          <radialGradient id="bg-gradient" cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#047857" />
          </radialGradient>
        </defs>

        {/* Arka plan çember */}
        <circle cx="24" cy="24" r="22" fill="url(#bg-gradient)" />

        {/* Çay bardağı gölgesi */}
        <ellipse cx="24" cy="40" rx="8" ry="2" fill="#000000" fillOpacity="0.1" />

        {/* Çay bardağı */}
        <path
          d="M14 18 L16 38 Q16 40 18 40 L30 40 Q32 40 32 38 L34 18 Z"
          fill="url(#cup-gradient)"
          stroke="#e2e8f0"
          strokeWidth="0.5"
        />

        {/* Çay sıvısı */}
        <path
          d="M15.5 20 L16.8 36 Q16.8 37.5 18 37.5 L30 37.5 Q31.2 37.5 31.2 36 L32.5 20 Z"
          fill="url(#tea-gradient)"
        />

        {/* Çay bardağı kenarı */}
        <ellipse
          cx="24"
          cy="18"
          rx="10"
          ry="2"
          fill="url(#cup-gradient)"
          stroke="#e2e8f0"
          strokeWidth="0.5"
        />

        {/* Kulp */}
        <path
          d="M34 24 Q38 24 38 28 Q38 32 34 32"
          fill="none"
          stroke="url(#cup-gradient)"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M34 24 Q37 24 37 28 Q37 32 34 32"
          fill="none"
          stroke="#e2e8f0"
          strokeWidth="1.5"
          strokeLinecap="round"
        />

        {/* Çay buharı */}
        <g opacity="0.7">
          <path
            d="M20 16 Q20 12 22 12 Q20 8 22 8"
            fill="none"
            stroke="url(#steam-gradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M24 16 Q24 12 26 12 Q24 8 26 8"
            fill="none"
            stroke="url(#steam-gradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M28 16 Q28 12 30 12 Q28 8 30 8"
            fill="none"
            stroke="url(#steam-gradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>

        {/* Çay yaprakları (dekoratif) */}
        <g opacity="0.3">
          <path d="M12 12 Q14 10 16 12 Q14 14 12 12" fill="#10b981" />
          <path d="M32 10 Q34 8 36 10 Q34 12 32 10" fill="#10b981" />
        </g>
      </svg>

      {showText && (
        <div className="flex flex-col">
          <h1 className="text-2xl font-bold text-green-700 leading-tight tracking-tight">
            Çay Sipariş
          </h1>
          <span className="text-lg font-semibold text-green-600 leading-tight -mt-1">Sistemi</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
